const initialSignupData = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
};

const initialLoginData = {
  email: "",
  password: "",
};
const guestCredentials = {
  email: "himmatsingh@gmail.com",
  password: "specialops1.5",
};
export { initialSignupData, initialLoginData, guestCredentials };
